export default "__VITE_ASSET__DbOzHdO$__"